import React from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'
import { FxCheckboxProps } from './FxCheckbox.props'
import { FxLabel } from '../label/FxLabel'

/**
 *
 * @param label
 * @param name
 * @param info
 * @param onValueChange
 * @param value
 * @param color
 * @param className
 * @param size
 * @param labelPlacement
 * @param disabled
 * @constructor
 */
export const FxCheckbox = ({
  label,
  name,
  path,
  className,
  info,
  onValueChange,
  value,
  color = "primary",
  size = "small",
  labelPlacement = "end",
  disabled
}: FxCheckboxProps) => {
  /**
   *
   * @param event
   */
  const onChange = (event: any) => {
    const value = event.target.checked;
    const data = { name, value, path }
    onValueChange(data)
  }

  const checkboxLabel = <FxLabel info={info} label={label} />
  return (
    <FormControlLabel
    className={`fx-checkbox ${className}`}
      control={<Checkbox checked={value} color={color} onChange={onChange} size={size} />}
      label={checkboxLabel}
      labelPlacement={labelPlacement}
      disabled={disabled} />
  )
}

